import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux'

import { getTranslator } from '../../locales';


/**
 * [ERROR_MESSAGES description]
 * @type {Object}
 */
const ERROR_MESSAGES = [
  'DEFAULT',
  'NOT_LOGGED_IN',
  'RETRYABLE_ACTION_DEFAULT',
  'CHAT_CLOSED_DETAILS',

  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
  'INTERNAL_SERVER_ERROR',
  'NOT_IMPLEMENTED',
  'BAD_GATEWAY',
  'SERVICE_UNAVAILABLE',
  'GATEWAY_TIMEOUT',
  'HTTP_VERSION_NOT_SUPPORTED',
  'VARIANT_ALSO_NEGOTIATES',
];

@connect((Store) => {
  const t = getTranslator();

  // Login message if login URL available
  // const loginURL = 'https://main-eng-frontend.pathmotion.local/login?next=/app/discussions/chat/view/ea7d807eb87f60675ddffd238d6128dd';
  const loginURL = Store.chat.chatLoginURL;
  let loginMessage = '';

  if (loginURL) {
    loginMessage = t.t(
      'Click <a href="%{login_url}">here</a> to log in.',
      { 'login_url': loginURL,  interpolation: { escapeValue: false } }
    );
  }

  const errorMessages = {
    DEFAULT: t.t('Sorry, an error occurred.'),
    NOT_LOGGED_IN: t.t(
      'Sorry, you must be logged in to access this Live Chat.%{login_message}',
      { 'login_message': ' ' + loginMessage, interpolation: { escapeValue: false } }
    ),
    CHAT_INIT_FAILED: t.t('Chat initialization failed. Service unavailable.'),
    CHAT_CLOSED_DETAILS: t.t(
      'The Live Chat has ended. You can still ask our Insiders questions on the PathMotion platform.'
    )
  };

  // Ability to pass predefined error codes:
  //   DEFAULT
  //   NOT_LOGGED_IN
  //   CHAT_INIT_FAILED
  // or
  // pass a custom string (needs to be translated)

  const errorCode = Store.alert.error;
  const errorMessage = _.has(errorMessages, errorCode) ?
    errorMessages[errorCode] : errorCode;

  return {
    errorCode,
    errorMessage
  };
})

export default class ErrorMessage extends React.Component {
  render() {
    const errorMessage = this.props.errorMessage + '<br />';

    if (errorMessage) {
      return (
        <span dangerouslySetInnerHTML={{__html: errorMessage}}></span>
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/notifier/ErrorMessage.jsx